<template>
  <div class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between">
        <h3 class="m-0">
          <i class="fa fa-users mr-3"></i>
          {{ $tc('word.user', 2) }}
        </h3>
        <div class="d-flex align-items-center">
          <div class="mr-1">
            <v-button
              v-if="searchQuery"
              size="sm"
              style-type="secondary"
              text="word.reset"
              @click="reset"
            />
          </div>
          <form method="post" @submit.prevent="filterObjects(searchQuery)">
            <v-text-input
              placeholder="word.search"
              v-model="searchQuery"
            />
          </form>
        </div>
      </div>
    </div>
    <div class="overflow-auto">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>{{ $t('word.username') }}</th>
          <th>{{ $t('word.name') }}</th>
          <th>{{ $t('word.coin_account') }}</th>
          <th>{{ $t('phrase.is_onboarded') }}</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(user, index) in objectList" :key="index">
          <td>
            {{ user.username }}
          </td>
          <td>
            {{ user.full_name }}
          </td>
          <td>
            <div v-if="user.coin_account">
              {{ user.coin_account.rate }}
              <div
                v-title="$t('word.active')"
                class="badge badge-success"
                v-if="user.coin_account.is_active"
              >
                <i class="fa fa-check"></i>
              </div>
            </div>
          </td>
          <td>
          <span v-if="user.is_onboarded">
            <i class="fa fa-check text-success"></i>
          </span>
            <span v-else>
            <i class="fa fa-times text-danger"></i>
          </span>
          </td>
          <td>
            <v-button
              style-type="secondary"
              size="sm"
              text="word.view"
              :route-to="{name: 'admin-user-detail', params: {id: user.id}}"
            />
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="p-3 d-flex justify-content-center">
      <v-button
        text="phrase.load_more"
        v-if="nextPageUrl"
        @click="getObjects(nextPageUrl, true)"
      />
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import { GenericListMixin } from '@/common/utils/mixins';

export default {
  name: 'UserList',
  components: {
    'v-button': Button,
    'v-text-input': TextInput,
  },
  data() {
    return {
      apiPath: 'admin/users/',
    };
  },
  mixins: [
    GenericListMixin,
  ],
};
</script>
